import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import CompanyInfoCard from 'page-sections/crm/CompanyInfoCard';
import UserProfileCard from 'page-sections/crm/UserProfileCard';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/free-mode';

import { myCommentsData, myPostsData } from 'page-sections/crm/MypageCardData';
import MyPostCard from './MyPostCard';

export default function UserInfoSection() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      <Grid item xs={12} lg={12}>
        <Grid container gap={2.5}>
          {/* User Profile Card */}
          <UserProfileCard
            isTablet={isTablet}
            isMobile={isMobile}
            userName="홍길동"
            userGrade="BRONZE 1"
            tagline="나만의 길을 찾고자는 걸어가는 마이로드^^"
            email="zzzz@naver.com"
            joinDate="2025.10.13"
            profileProgress={85}
            stats={{
              followers: 867,
              following: 341,
              posts: 43,
              comments: 76,
            }}
            avatarUrl="/static/avatar/001-man.svg"
          />

          {/* Company Information Card */}
          <CompanyInfoCard
            isTablet={isTablet}
            isMobile={isMobile}
            companyName="한솔농산"
            completionPercentage={91}
            description="기업의 세부 정보를 추가 업데이트하면, 더 정확하게 정부지원금, 정책자금이 추천돼요!"
          />

          {/* Third row with the original comment cards */}
          <Grid container spacing={isTablet ? 2.5 : 2} alignItems="stretch">
            <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
              <MyPostCard
                isTablet={isTablet}
                isMobile={isMobile}
                title={myPostsData.title}
                count={myPostsData.count}
                icon={myPostsData.icon}
                navigationRoute={myPostsData.navigationRoute}
                postsData={myPostsData.postsData}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
              <MyPostCard
                isTablet={isTablet}
                isMobile={isMobile}
                title={myCommentsData.title}
                count={myCommentsData.count}
                icon={myCommentsData.icon}
                navigationRoute={myCommentsData.navigationRoute}
                postsData={myCommentsData.postsData}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
